import { CreditCardType } from 'types/payments';

export const toCreditCardType = (csCardType: string): CreditCardType | null => {
  switch (csCardType) {
    case '001':
      return CreditCardType.Visa;
    case '002':
      return CreditCardType.MasterCard;
    case '003':
      return CreditCardType.Amex;
    default:
      return null;
  }
};
